var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.segments, function(segment, ind) {
      return _c("span", { key: ind }, [
        ind > 0 ? _c("span", { staticClass: "separator" }) : _vm._e(),
        _vm._v(" "),
        segment.link
          ? _c(
              "span",
              {
                staticClass: "cursor-pointer thick",
                on: {
                  click: function($event) {
                    _vm.$router.push(segment.link)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(segment.label) + "\n    ")]
            )
          : _c("span", { staticClass: "thick" }, [
              _vm._v(_vm._s(segment.label))
            ])
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01fcaa0e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01fcaa0e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/unit-path.vue
// module id = null
// module chunks = 